// noinspection DuplicatedCode

import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import Paper from '@/modules/common/components/Paper';
import Button from '@/modules/common/components/Button';
import Content from '@/modules/common/components/Content';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import Pagination from '@/modules/common/components/Pagination';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import ContentBodyTop from '@/modules/common/components/ContentBodyTop';
import { withFetch } from '~/hocs/fetch';
import { withRouter } from '~/hocs/router';
import Table from './Table';
import DialogAdd from './DialogAdd';
import DialogEdit from './DialogEdit';
import ContextMenu from './ContextMenu';
import DialogDelete from './DialogDelete';
import '../../styles/Offers.scss';

const breadcrumbs = [
    {name: 'Офферы'}
];

let abortController;

const Offers = (props) => {
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [selectedOffer, setSelectedOffer] = useState(null);
    const [openDialogAdd, setOpenDialogAdd] = useState(false);
    const [openDialogEdit, setOpenDialogEdit] = useState(false);
    const [openDialogDelete, setOpenDialogDelete] = useState(false);
    const [positionContextMenu, setPositionContextMenu] = useState({left: null, top: null});

    const fetch = () => {
        abortController = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/offers/?${props.router.urlSearchParams.toString()}`, abortController)
            .then(({ok, data}) => {
                if (ok) {
                    setData(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                setData(null);
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController = null;
            });
    };

    const closeContextMenu = () => {
        setPositionContextMenu({left: null, top: null});
    };

    useEffect(() => {
        return () => {
            if (abortController) {
                abortController.abort();
            }
        };
    }, []);

    useEffect(() => {
        let page = parseInt(props.router.urlSearchParams.get('page'));

        if (isNaN(page)) {
            page = 1;
        }
        // noinspection JSCheckFunctionSignatures
        props.router.urlSearchParams.set('page', page);

        fetch();
    }, [props.history.location.search]);

    //******************************************************************************************************************

    const handleContextMenu = (offer) => (event) => {
        event.preventDefault();
        setSelectedOffer(offer);
        setPositionContextMenu({left: event.clientX, top: event.clientY});
    };

    const handleClickEdit = () => {
        closeContextMenu();
        setOpenDialogEdit(true);
    };

    const handleClickDelete = () => {
        closeContextMenu();
        setOpenDialogDelete(true);
    };

    const handleCloseContextMenu = () => {
        closeContextMenu();
        setSelectedOffer(null);
    };

    //******************************************************************************************************************

    const handleAddOk = () => {
        setOpenDialogAdd(false);
        props.router.reload();
        enqueueSnackbar('Оффер добавлен', {variant: 'success'});
    };

    const handleEditOk = () => {
        setOpenDialogEdit(false);
        setSelectedOffer(null);
        props.router.reload();
        enqueueSnackbar('Оффер изменен', {variant: 'success'});
    };

    const handleDeleteOk = () => {
        setOpenDialogDelete(false);
        setSelectedOffer(null);
        props.router.reload();
        enqueueSnackbar('Оффер удален', {variant: 'success'});
    };

    //******************************************************************************************************************

    // noinspection JSUnresolvedVariable
    return (
        <Content id="offers">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody><Paper>
                {(!loading)
                    ? <>
                        {(data && data.results)
                            ? <>
                                <ContentBodyTop left={
                                    <Button onClick={() => setOpenDialogAdd(true)}>Добавить</Button>
                                }/>
                                <DialogAdd open={openDialogAdd} setOpen={setOpenDialogAdd} onOk={handleAddOk}/>
                                {(data.results.length > 0)
                                    ? <>
                                        <Table items={data.results} selectedOffer={selectedOffer}
                                               onContextMenu={handleContextMenu}
                                        />
                                        <ContextMenu position={positionContextMenu}
                                                     onClickEdit={handleClickEdit} onClickDelete={handleClickDelete}
                                                     onClose={handleCloseContextMenu}
                                        />
                                        <DialogEdit selectedOffer={selectedOffer} setSelectedOffer={setSelectedOffer}
                                                    open={openDialogEdit} setOpen={setOpenDialogEdit}
                                                    onOk={handleEditOk}
                                        />
                                        <DialogDelete selectedOffer={selectedOffer} setSelectedOffer={setSelectedOffer}
                                                      open={openDialogDelete} setOpen={setOpenDialogDelete}
                                                      onOk={handleDeleteOk}
                                        />
                                        <Pagination totalPages={data.total_pages} currentPage={data.current_page}/>
                                    </>
                                    : null
                                }
                            </>
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </Paper></ContentBody>
        </Content>
    );
};

let Component = Offers;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;

